import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';

export function isViolationTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.newViolationFound ||
    triggerType === TriggerTypes.newOrExistingViolationFound ||
    triggerType === TriggerTypes.existingViolationFound
  );
}

export function isResourceTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.newResourceFound ||
    triggerType === TriggerTypes.newOrExistingResourceFound ||
    triggerType === TriggerTypes.existingResourceFound
  );
}

export function isBrownfieldTrigger(triggerType: TriggerTypes): boolean {
  return (
    triggerType === TriggerTypes.existingResourceFound ||
    triggerType === TriggerTypes.existingViolationFound ||
    triggerType === TriggerTypes.newOrExistingResourceFound ||
    triggerType === TriggerTypes.newOrExistingViolationFound
  );
}
